"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useAsyncRateLimiter = require("./useAsyncRateLimiter.cjs");
function useAsyncRateLimitedCallback(fn, options) {
  const asyncRateLimitedFn = useAsyncRateLimiter.useAsyncRateLimiter(fn, options).maybeExecute;
  return react.useCallback(
    (...args) => asyncRateLimitedFn(...args),
    [asyncRateLimitedFn]
  );
}
exports.useAsyncRateLimitedCallback = useAsyncRateLimitedCallback;
//# sourceMappingURL=useAsyncRateLimitedCallback.cjs.map
